var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 2.00718L9.99277 1.00004L5.99992 4.9929L2.00706 1.00004L0.999916 2.00718L4.99277 6.00004L0.999916 9.9929L2.00706 11L5.99992 7.00718L9.99277 11L10.9999 9.9929L7.00706 6.00004L10.9999 2.00718Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00706 0.646484L5.99992 4.63934L9.99277 0.646484L11.3535 2.00718L7.36061 6.00004L11.3535 9.9929L9.99277 11.3536L5.99992 7.36073L2.00706 11.3536L0.646362 9.9929L4.63922 6.00004L0.646362 2.00718L2.00706 0.646484ZM1.35347 2.00718L5.34633 6.00004L1.35347 9.9929L2.00706 10.6465L5.99992 6.65363L9.99277 10.6465L10.6464 9.9929L6.65351 6.00004L10.6464 2.00718L9.99277 1.35359L5.99992 5.34645L2.00706 1.35359L1.35347 2.00718Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cross.2c180c9d.svg";
export { ForwardRef as ReactComponent };